import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';
import mushodoCheckStatusBackgroundJob from '@webapp-next/lib/request/webapp/mushodo-check-status-background-job';

/**
 * Get the number of minutes difference between the user's timezone
 * and the timezone set for the location
 * @param {Object} vars
 * @param {String[]} vars.payrollIds
 * @param {Number[]} vars.locationIds
 * @return {Object}
 */
export default async function getTeamPayrollConfig({
  payrollIds,
  locationIds,
}) {
  try {
    const { strSyncKey } = await mushodoPromise('GetTeamPayrollConfig', {
      strServiceArray: payrollIds,
      intCompanyIdArray: locationIds,
    });

    return new Promise(function(resolve, reject) {
      (async function isCompleted() {
        if (strSyncKey) {
          const status = await mushodoCheckStatusBackgroundJob(strSyncKey);

          if (status.success && !status.result?.strSyncKey) {
            return resolve({
              success: true,
              mesasge: '',
              data: status.result || {},
            });
          } else if (status.result?.error) {
            return reject(
              status.result?.error || 'Unable to get payroll config'
            );
          }
        }
        setTimeout(isCompleted, 1000);
      })();
    });
  } catch (e) {
    throw e;
  }
}
